<script>
export default {
  data() {
    return {
      spotlight: { x: 50, y: 40 },
      rafId: null,
      pending: null,
    };
  },
  created() {
    document.body.style.background = 'transparent';
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.onMouseMove);
    if (this.rafId) cancelAnimationFrame(this.rafId);
  },
  mounted() {
    window.addEventListener('mousemove', this.onMouseMove, { passive: true });
  },
  methods: {
    onMouseMove(e) {
      this.pending = {
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100,
      };
      if (this.rafId) return;
      this.rafId = requestAnimationFrame(() => {
        if (this.pending) {
          this.spotlight = this.pending;
          this.pending = null;
        }
        this.rafId = null;
      });
    },
  },
};
</script>

<template>
  <div>
    <div class="auth-bg-root">
      <div class="auth-bg" aria-hidden="true">
        <div class="auth-bg__gradient"></div>
        <div
          class="auth-bg__spotlight"
          :style="{
            '--sx': spotlight.x + '%',
            '--sy': spotlight.y + '%',
          }"
        ></div>
        <div class="auth-bg__orb auth-bg__orb--1"></div>
        <div class="auth-bg__orb auth-bg__orb--2"></div>
      </div>

      <div class="account-pages">
        <div class="container-fluid px-0">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.auth-bg-root {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: linear-gradient(145deg, #070b14 0%, #0d1528 45%, #111827 100%);
}

.auth-bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.auth-bg__gradient {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 70% 55% at 15% 20%, rgba(6, 182, 212, 0.1), transparent 55%),
    radial-gradient(ellipse 55% 45% at 88% 75%, rgba(59, 130, 246, 0.08), transparent 50%);
}

.auth-bg__spotlight {
  position: absolute;
  inset: 0;
  background: radial-gradient(
    520px circle at var(--sx, 50%) var(--sy, 40%),
    rgba(186, 230, 253, 0.22) 0%,
    rgba(125, 211, 252, 0.12) 28%,
    rgba(56, 189, 248, 0.05) 48%,
    transparent 68%
  );
  transition: background 0.08s linear;
  will-change: background;
}

.auth-bg__orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.7;
}

.auth-bg__orb--1 {
  width: 420px;
  height: 420px;
  top: -12%;
  left: -10%;
  background: rgba(6, 182, 212, 0.14);
}

.auth-bg__orb--2 {
  width: 360px;
  height: 360px;
  bottom: -8%;
  right: -6%;
  background: rgba(59, 130, 246, 0.12);
}

.account-pages {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  align-items: center;
}

@media (prefers-reduced-motion: reduce) {
  .auth-bg__spotlight {
    transition: none;
  }
}
</style>
